import { render, staticRenderFns } from "./ProfileLocationForms.vue?vue&type=template&id=2fba31bc&scoped=true&"
import script from "./ProfileLocationForms.vue?vue&type=script&lang=js&"
export * from "./ProfileLocationForms.vue?vue&type=script&lang=js&"
import style0 from "./ProfileLocationForms.vue?vue&type=style&index=0&id=2fba31bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fba31bc",
  null
  
)

export default component.exports